import {injectable} from "inversify";

export const APP_PROPERTIES_NAME = "appProperties";

export interface AppProperties {

    getBaseUrl(): string;

}

@injectable()
export class AppPropertiesImpl implements AppProperties {

    constructor() {

    }

    getBaseUrl(): string {
        return "http://localhost:8080/dashboard/rest";
    }

}


// WEBPACK FOOTER //
// ./src/app/AppProperties.ts